import { Info } from "./Info";
import { ConfirmNumber } from "./ConfirmNumber";

const register = {
  Info,
  ConfirmNumber
}

export default register